import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const About = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>About Us – Naijads.ng</title>
        <meta
          name="description"
          content="Naijads.ng is Nigeria's trusted free classifieds marketplace. Sell your goods, rent property, find jobs or post services — all across Naija!"
        />
        <link rel="canonical" href="https://naijads.ng/about" />
        <meta property="og:title" content="About Us – Naijads.ng" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            mainEntity: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              url: 'https://naijads.ng',
              logo: 'https://naijads.ng/assets/Tayo.svg',
            },
            description:
              'Naijads.ng is a free classifieds platform for buying, selling, renting, and promoting services across Nigeria — from Lagos to Abuja and beyond.',
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>About Us</h1>
          <p>
            <strong>Naijads.ng</strong> is a proudly Nigerian online marketplace where you fit post free classifieds for any type of wahala-free buying and selling. Whether
            na phone, land, tokunbo car or even second-hand fridge — Naijads connects you with serious buyers all across Nigeria.
          </p>
          <p>
            Our platform supports local hustlers, small businesses and everyday folks looking to cash out or save money on useful items and services.
          </p>
        </div>

        <div className="info-block">
          <h3>Our mission</h3>
          <p>
            Our mission is to empower local Nigerians with a secure, accessible and free space to buy, sell and promote — with strong community spirit and trust.
          </p>
        </div>

        <div className="info-block">
          <h3>What you Can post</h3>
          <ul>
            <li>
              <strong>Real Estate:</strong> Rent or sell flats, self-contain, shops and land
            </li>
            <li>
              <strong>Vehicles:</strong> Cars, okadas, tricycles and spare parts
            </li>
            <li>
              <strong>Jobs:</strong> Hire staff or find legit work
            </li>
            <li>
              <strong>Services:</strong> Promote your hustle — hair styling, catering, repairs
            </li>
            <li>
              <strong>Everything Else:</strong> Phones, home goods, pets, baby gear
            </li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Where you can Place ads</h3>
          <p>
            You can <strong>post ads for free</strong> across all 36 states of Nigeria, including FCT Abuja. We dey live in:
          </p>
          <p className="state-list">
            <em>
              Lagos, Kano, Rivers, Kaduna, Delta, Enugu, Oyo, Akwa Ibom, Ogun, Edo, Plateau, Abia, Bayelsa, Kwara, Sokoto, Benue, Imo, Bauchi, Borno, Niger, and more!
            </em>
          </p>
        </div>

        <div className="info-block">
          <h3>Why choose Naijads.ng?</h3>
          <ul>
            <li>
              <strong>Totally Free:</strong> No fees, no subscription — just post and go!
            </li>
            <li>
              <strong>Naija Focused:</strong> Built for local needs and vibes
            </li>
            <li>
              <strong>Fast & Clean UI:</strong> Post your items sharp-sharp
            </li>
            <li>
              <strong>SEO-Friendly:</strong> Google go pick your ad quick
            </li>
            <li>
              <strong>Mobile Friendly:</strong> Easy to use from Android or iPhone
            </li>
          </ul>
        </div>

        <div className="info-block-main">
          <p>
            Naijads no be just website — na full online community wey connect sellers and buyers wey ready. No wahala, no middleman. Just real people across Naija wey dey
            hustle and shine.
          </p>
          <p>
            <strong>Start posting now and let your items jollof online!</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
